export default __webpack_public_path__ + "static/media/1587.91d1a743.png";